class NotificationShowAll {
  private element: HTMLButtonElement;

  constructor(element: HTMLButtonElement) {
    this.element = element;

    this.setClickHandler = this.setClickHandler.bind(this);
  }

  showButton() {
    this.element.classList.remove(`notifications__show-all--hide`);
  }

  hideButton() {
    this.element.classList.add(`notifications__show-all--hide`);
  }


  setClickHandler(callback) {
    this.element.addEventListener(`click`, callback);
  }
}

export {NotificationShowAll};
